import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback } from 'react';
import { triggerMarkAllReadButtonClicked, triggerNotificationsAPICallFailed, triggerNotificationsAPICallSucceeded, useCreateFireAnalyticsFromTrigger } from '@atlassian/notification-common';
import { RequestCategory, RequestReadState } from '@atlassian/notification-common/types';
import { useNotificationReadStateFilter, useNotificationStateFilters } from '../../../use-notification-list-filters-store/store';
import { useNotificationActions } from '../../store';
export function useGroupReadStateActions() {
  var _useNotificationActio = useNotificationActions(),
    _useNotificationActio2 = _slicedToArray(_useNotificationActio, 2),
    actions = _useNotificationActio2[1];
  var _useNotificationState = useNotificationStateFilters(),
    _useNotificationState2 = _slicedToArray(_useNotificationState, 1),
    filters = _useNotificationState2[0];
  var _useNotificationReadS = useNotificationReadStateFilter(),
    _useNotificationReadS2 = _slicedToArray(_useNotificationReadS, 1),
    readState = _useNotificationReadS2[0];
  var markGroup = actions.markGroup,
    markGroupNotifications = actions.markGroupNotifications,
    markAllGroupsAsRead = actions.markAllGroupsAsRead,
    disableListFetching = actions.disableListFetching;
  var fireNotificationsAPICallSucceeded = useCreateFireAnalyticsFromTrigger(triggerNotificationsAPICallSucceeded);
  var fireNotificationsAPICallFailed = useCreateFireAnalyticsFromTrigger(triggerNotificationsAPICallFailed);
  var fireMarkAllReadButtonClicked = useCreateFireAnalyticsFromTrigger(triggerMarkAllReadButtonClicked);
  var handleMarkGroup = useCallback(function (groupId, toState) {
    markGroup(groupId, toState, readState, {
      onSuccess: fireNotificationsAPICallSucceeded,
      onError: fireNotificationsAPICallFailed
    });
  }, [markGroup, fireNotificationsAPICallSucceeded, fireNotificationsAPICallFailed, readState]);
  var handleMarkGroupNotifications = useCallback(function (groupId, notificationIds, toState) {
    markGroupNotifications(groupId, notificationIds, toState, readState, {
      onSuccess: fireNotificationsAPICallSucceeded,
      onError: fireNotificationsAPICallFailed
    });
  }, [markGroupNotifications, fireNotificationsAPICallSucceeded, fireNotificationsAPICallFailed, readState]);
  var handleMarkAllGroupsAsRead = useCallback(function (location) {
    // Only disable fetching for the filters with 'UNREAD' read state
    if (readState === RequestReadState.UNREAD) {
      disableListFetching(filters);
    }
    markAllGroupsAsRead(filters.categoryFilter === RequestCategory.DIRECT, readState, {
      onSuccess: fireNotificationsAPICallSucceeded,
      onError: fireNotificationsAPICallFailed
    });
    fireMarkAllReadButtonClicked(location);
  }, [disableListFetching, filters, fireMarkAllReadButtonClicked, markAllGroupsAsRead, fireNotificationsAPICallSucceeded, fireNotificationsAPICallFailed, readState]);
  return {
    handleMarkGroup: handleMarkGroup,
    handleMarkGroupNotifications: handleMarkGroupNotifications,
    handleMarkAllGroupsAsRead: handleMarkAllGroupsAsRead
  };
}